import { groupService } from '../_services';
import { router } from '../router/index';

const actions = {
    create( bodyParams ) {
        groupService.create(bodyParams).then(
            data => {
                return data;
            }
        ).catch((error) => {
            console.log(error);
            return error;
        }
        );    
    },
    get( object_id ){
        groupService.get(object_id).then(
            data => {
                return data;
            }
        ).catch((error) => {
            console.log(error);
            return error;
        }
        );    
    },
};

const mutations = {
};

export const group = {
    namespaced: true,
    actions,
    mutations
};